import styled from 'styled-components';

const FallbackStyled = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.space[7],
}));

const LabelStyled = styled.span(({ theme }) => ({
  marginTop: theme.space[3],
  fontWeight: theme.font.weight.xbold,
  fontSize: theme.font.size.default,
  color: theme.color.wfBlack,
}));

export { FallbackStyled, LabelStyled };
